import { useCallback } from 'react';
import { useSelector } from 'react-redux';
// Redux
import {
  actions,
  selectors as propertyFeatureSelectors
} from 'src/features/propertyFeature/propertyFeatureSlice';

// Hooks
import { useAppDispatch } from 'src/store';
import { getAll } from '../services';
// Enums
import { FeatureState } from 'src/ts/enums';

const useProperty = () => {
  const dispatch = useAppDispatch();

  const propertyFeatures = useSelector(propertyFeatureSelectors.getAll.data);
  const propertyFeatureIsIdle = useSelector(propertyFeatureSelectors.getAll.isIdle);
  const propertyFeatureIsLoading = useSelector(propertyFeatureSelectors.getAll.isLoading);

  const onGetAll = useCallback(
    (propertyId: string) => {
      dispatch(getAll(propertyId));
    },
    [dispatch]
  );

  const onResetGetAll = useCallback(() => {
    dispatch(actions.resetGetAll());
  }, [dispatch]);

  const getIsPropertyFeatureActive = useCallback(
    (code: string) => {
      return (
        propertyFeatures?.some(
          (feature) => feature.code === code && feature.state === FeatureState.ENABLED
        ) || false
      );
    },
    [propertyFeatures]
  );

  return {
    onGetAll,
    onResetGetAll,
    getIsPropertyFeatureActive,
    propertyFeatureIsIdle,
    propertyFeatureIsLoading
  };
};

export default useProperty;
